import { useDispatch, useSelector } from 'react-redux';

import { Modal } from '@frontend/legacy-components';

import WorkflowForm from './WorkflowForm';
import { workflowModal } from './data/actions';
import { getIsOpen } from './data/reducer';

const WorkflowModal = () => {
  const dispatch = useDispatch();
  const onClose = () => dispatch(workflowModal.close());
  const isOpen = useSelector(getIsOpen);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <WorkflowForm />
    </Modal>
  );
};

export default WorkflowModal;
